import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { shouldOpenInNewTab, buildNavigationUrl } from '../utils/navigationUtils';


export const useSmartNavigation = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const smartNavigate = useCallback((targetPath, options = {}) => {
        const { forceNewTab = false, forceSameTab = false, replace = false } = options;
        
        // Build the full URL with any query parameters
        const fullPath = buildNavigationUrl(targetPath, {
            currentPath: location.pathname,
            searchParams: location.search
        });
        
        // Determine if should open in new tab
        let openInNewTab = shouldOpenInNewTab(location.pathname, targetPath);
        
        // Override with force options if provided
        if (forceNewTab) {
            openInNewTab = true;
        } else if (forceSameTab) {
            openInNewTab = false;
        }
        
        if (openInNewTab) {
            // Notify any listeners (e.g. pages with active edit locks) before opening a new tab details is optional data
            window.dispatchEvent(new CustomEvent('beforeSmartNavigateNewTab', { detail: { path: fullPath } }));
            // Open in new tab
            const url = window.location.origin + fullPath;
            window.open(url, '_blank')?.focus();
        } else {
            const sameTabNavigationEvent = new CustomEvent('beforeSmartNavigateSameTab', {
                detail: { path: fullPath, replace },
                cancelable: true,
            });

            const canProceed = window.dispatchEvent(sameTabNavigationEvent);
            if (!canProceed) {
                return;
            }

            // Navigate in same tab using React Router
            navigate(fullPath, { replace });
        }
    }, [navigate, location.pathname, location.search]);

    return smartNavigate;
};

export default useSmartNavigation;
